import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';

import { DatabusService } from '../services/databus.service';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ValidationService {
  private url = environment.url;
  private clientId = environment.clientId;
  private clubCard = environment.clubCard;
  private customer = environment.customer;
  private assignCard = environment.assignCard;
  private assignTicket = environment.assignTicket;
  private redeemed = environment.redeemed;
  private login = environment.login;

  private headers = new Headers({'x-client-id': this.clientId });
  private options = new RequestOptions({headers: this.headers});

  constructor(
    private http: Http,
    private dataSrv: DatabusService
  ) {}

  accountLogin(creds) {
    return this.http
    .post(this.url + this.login, creds, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  customerStatus (email) {
    return this.http
    .put(this.url + this.customer, email, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  checkTicket (ticket) {
    return this.http
    .get(this.url + this.redeemed + ticket, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  checkClubCard(cardNumber): Promise<any> {
    return this.http
      .get(this.url + this.clubCard + cardNumber, this.options)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  checkEmail(email): Promise<any> {
    return this.http
      .get(this.url + this.customer + '?email=' + email, this.options)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  checkCardAndTicket(card, ticket): Promise<any> {
    let payload = {
      cardCode: card,
      code: ticket
    },
    postUrl = this.url + this.customer;

    return this.http
      .post(postUrl, payload, this.options)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  assignTicketAccount(ticket) {
    return this.http
    .post(this.url + this.assignTicket, ticket, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  addAccount (account) {
    let payload = {
      name: account.firstName + ' ' + account.lastName,
      email: account.email,
      password: account.password
    }

    return this.http.post(this.url + this.customer, payload, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  assignCardCode (card) {
    return this.http.post(this.url + this.assignCard, card, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  completeProfile(profile) {
    return this.http.put(this.url + this.customer, profile, this.options)
    .toPromise()
    .then(response => response.json() as any)
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error);
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/services/validation.service.ts